export const INSTACART_CLIENT_CONFIGURATION_ID = '1'

// Retailer App IDs defined here: https://github.com/instacart/carrot/blob/master/customers/customers-backend/domains/orders_domain/app/domain/orders_domain/api/get_order_visibility_rules/api.rb#L496
// Retailer APP IDs
export const WEGMANS_RETAILER_APP_ID = '3001'
export const WALMART_CA_RETAILER_APP_ID = '3002'
export const SMART_AND_FINAL_RETAILER_APP_ID = '3003'
export const WEGAMNS_FOR_BUSINESS_RETAILER_APP_ID = '3004'
export const COSTCO_US_RETAILER_APP_ID = '3005'
export const WOODMANS_FOOD_MARKETS_RETAILER_APP_ID = '3006'
export const COSTCO_CA_RETAILER_APP_ID = '3007'
export const COSTCO_BUSINESS_RETAILER_APP_ID = '3008'
export const SPROUTS_RETAILER_APP_ID = '3009'
export const HARMONS_RETAILER_APP_ID = '3010'
export const WAKEFERN_FAIRWAY_MARKET_RETAILER_APP_ID = '3011'
export const FOOD_GARDEN_MARKET_RETAILER_APP_ID = '3012'
export const TOPS_MARKETS_RETAILER_APP_ID = '3013'
export const PCNY_RETAILER_APP_ID = '3014'
export const ALDI_RETAILER_APP_ID = '3015'
export const NIEMANNS_RETAILER_APP_ID = '3016'
export const FOODSTORM_RETAILER_APP_ID = '3017'
export const CROPS_MARKETPLACE_RETAILER_APP_ID = '3018'
export const LEES_MARKETPLACE_RETAILER_APP_ID = '3019'
export const FOOD_BAZAAR_RETAILER_APP_ID = '3020'
export const NIEMANNS_HARVEST_MARKET_RETAILER_APP_ID = '3021'

// Retailer IDs
export const WEGMANS_RETAILER_ID = '231'
export const WALMART_CA_RETAILER_ID = '462'
export const WEGMANS_FOR_BUSINESS_RETAILER_ID = '3085'
export const SMART_AND_FINAL_RETAILER_ID = '105'
export const COSTCO_US_RETAILER_ID = '5'
export const WOODMANS_FOOD_MARKETS_RETAILER_ID = '1396'
export const COSTCO_CA_RETAILER_ID = '354'
export const COSTCO_BUSINESS_RETAILER_ID = '195'
export const SPROUTS_RETAILER_ID = '279'
export const HARMONS_RETAILER_ID = '3060'
export const WAKEFERN_FAIRWAY_MARKET_RETAILER_ID = '1339'
export const FOOD_GARDEN_MARKET_RETAILER_ID = '2393'
export const TOPS_MARKETS_RETAILER_ID = '318'
export const PCNY_RETAILER_ID = '282'
export const ALDI_RETAILER_ID = '12'
export const NIEMANNS_RETAILER_ID = '2584'
export const FOODSTORM_RETAILER_ID = '1902'
export const CROPS_MARKETPLACE_RETAILER_ID = '2837'
export const LEES_MARKETPLACE_RETAILER_ID = '1310'
export const FOOD_BAZAAR_RETAILER_ID = '544'
export const NIEMANNS_HARVEST_MARKET_RETAILER_ID = '2002'

// Mapping
export const RETAILER_APP_ID_MAP = new Map<string, string>([
  [WEGMANS_RETAILER_ID, WEGMANS_RETAILER_APP_ID],
  [WALMART_CA_RETAILER_ID, WALMART_CA_RETAILER_APP_ID],
  [WEGMANS_FOR_BUSINESS_RETAILER_ID, WEGAMNS_FOR_BUSINESS_RETAILER_APP_ID],
  [SMART_AND_FINAL_RETAILER_ID, SMART_AND_FINAL_RETAILER_APP_ID],
  [COSTCO_US_RETAILER_ID, COSTCO_US_RETAILER_APP_ID],
  [WOODMANS_FOOD_MARKETS_RETAILER_ID, WOODMANS_FOOD_MARKETS_RETAILER_APP_ID],
  [COSTCO_CA_RETAILER_ID, COSTCO_CA_RETAILER_APP_ID],
  [COSTCO_BUSINESS_RETAILER_ID, COSTCO_BUSINESS_RETAILER_APP_ID],
  [SPROUTS_RETAILER_ID, SPROUTS_RETAILER_APP_ID],
  [HARMONS_RETAILER_ID, HARMONS_RETAILER_APP_ID],
  [WAKEFERN_FAIRWAY_MARKET_RETAILER_ID, WAKEFERN_FAIRWAY_MARKET_RETAILER_APP_ID],
  [FOOD_GARDEN_MARKET_RETAILER_ID, FOOD_GARDEN_MARKET_RETAILER_APP_ID],
  [TOPS_MARKETS_RETAILER_ID, TOPS_MARKETS_RETAILER_APP_ID],
  [PCNY_RETAILER_ID, PCNY_RETAILER_APP_ID],
  [ALDI_RETAILER_ID, ALDI_RETAILER_APP_ID],
  [NIEMANNS_RETAILER_ID, NIEMANNS_RETAILER_APP_ID],
  [FOODSTORM_RETAILER_ID, FOODSTORM_RETAILER_APP_ID],
  [CROPS_MARKETPLACE_RETAILER_ID, CROPS_MARKETPLACE_RETAILER_APP_ID],
  [LEES_MARKETPLACE_RETAILER_ID, LEES_MARKETPLACE_RETAILER_APP_ID],
  [FOOD_BAZAAR_RETAILER_ID, FOOD_BAZAAR_RETAILER_APP_ID],
  [NIEMANNS_HARVEST_MARKET_RETAILER_ID, NIEMANNS_HARVEST_MARKET_RETAILER_APP_ID],
])
